import { ContainerModule } from 'inversify';
import type { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import LogoUploadDispatcherFactory from '../LogoUploadDispatcherFactory';
import { LogoSocketProcessingAdapterFactory } from '../LogoSocketProcessingAdapter';
import { DILogoUploadTypes } from './types';
import type {
  ILogoSocketProcessingAdapterFactory,
  ILogoSocketProcessingAdapterMethod,
  ILogoUploadDispatcherFactory,
  ILogoUploadDispatcherFactoryMethod,
} from './interfaces';

export const LogoUploadDispatcherModule = new ContainerModule(({ bind }) => {
  bind<ILogoUploadDispatcherFactory>(DILogoUploadTypes.LogoUploadDispatcherFactory)
    .to(LogoUploadDispatcherFactory).inSingletonScope();

  bind<ILogoSocketProcessingAdapterFactory>(DILogoUploadTypes.LogoSocketProcessingAdapterFactory)
    .to(LogoSocketProcessingAdapterFactory).inSingletonScope();

  bind<ILogoUploadDispatcherFactoryMethod>(DILogoUploadTypes.LogoUploadDispatcher).toFactory(({ get }) =>
    (tenantCode?: DataroomTenant) => (
      get<ILogoUploadDispatcherFactory>(DILogoUploadTypes.LogoUploadDispatcherFactory)
        .create(tenantCode)
    ),
  );

  bind<ILogoSocketProcessingAdapterMethod>(DILogoUploadTypes.LogoSocketProcessingAdapter).toFactory(({ get }) =>
    (tenantCode?: DataroomTenant) => (
      get<ILogoSocketProcessingAdapterFactory>(DILogoUploadTypes.LogoSocketProcessingAdapterFactory)
        .create(tenantCode)
    ),
  );
});
